import { Box, styled, Typography } from '@mui/material';

export const CircleBox = styled(Box)(() => ({
  borderRadius: '100%',
  position: 'relative',
  width: '40%',
  paddingTop: '40%',
}));

export const TypoMiddle = styled(Typography)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
}));
